import JSZip from "jszip"
import { storeFile, clearAudioFiles } from "./db"

// Function to determine if the filename is a macOS system file or a directory
const isMacosSystemFileOrDirectory = (filename) => {
  return filename.startsWith("__MACOSX/") || filename.startsWith(".")
}

// Download ZIP file
export async function downloadAndUnzipAudioFiles(url: string): Promise<void> {
  // Clear the IndexedDB database of audio files already stored
  await clearAudioFiles()

  // Download and fetch the ZIP file from the given URL
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(
      `Failed to download ZIP: ${response.status} ${response.statusText}`
    )
  }

  const arrayBuffer = await response.arrayBuffer()

  // Load and extract the ZIP file
  const zip = await JSZip.loadAsync(arrayBuffer)

  // Loop over each file in the ZIP
  for (const [filename, zipEntry] of Object.entries(zip.files)) {
    // Make sure it's not a folder or a macOS system file
    if (!zipEntry.dir && !isMacosSystemFileOrDirectory(filename)) {
      // Extract the file as a Blob
      const blob = await zipEntry.async("blob")
      // Store file in IndexedDB
      await storeFile(filename, blob)
    }
  }
}
